/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEmailPreviewDto
 */
export interface GetEmailPreviewDto {
    /**
     * 
     * @type {string}
     * @memberof GetEmailPreviewDto
     */
    emailPl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEmailPreviewDto
     */
    emailEn?: string | null;
}

/**
 * Check if a given object implements the GetEmailPreviewDto interface.
 */
export function instanceOfGetEmailPreviewDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetEmailPreviewDtoFromJSON(json: any): GetEmailPreviewDto {
    return GetEmailPreviewDtoFromJSONTyped(json, false);
}

export function GetEmailPreviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmailPreviewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailPl': !exists(json, 'emailPl') ? undefined : json['emailPl'],
        'emailEn': !exists(json, 'emailEn') ? undefined : json['emailEn'],
    };
}

export function GetEmailPreviewDtoToJSON(value?: GetEmailPreviewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailPl': value.emailPl,
        'emailEn': value.emailEn,
    };
}

